export const FSR_CATEGORIES = [
    'ENVIRONMENTAL_ACCESS_CONCERNS',
    'HOME_ACCESS_ISSUES',
    'HOUSEHOLD_NOTES',
    'SANITATION_RISKS',
    'AREA_AFTER_HOURS',
] as const;

export type FieldSafetyReportCategory = (typeof FSR_CATEGORIES)[number];

export const FSR_CATEGORY_LABELS: Record<FieldSafetyReportCategory, string> = {
    ENVIRONMENTAL_ACCESS_CONCERNS: 'Environmental Access Concerns',
    HOME_ACCESS_ISSUES: 'Home Access Issues',
    HOUSEHOLD_NOTES: 'Household Notes',
    SANITATION_RISKS: 'Sanitation Risks',
    AREA_AFTER_HOURS: 'Area After Hours',
};

export const getFsrCategoryLabel = (reportType: string): string =>
    FSR_CATEGORY_LABELS[reportType as FieldSafetyReportCategory] ?? reportType;

export const getFsrCreatedBy = (sharedBy?: string): string => {
    if (!sharedBy || sharedBy.length === 0) return 'N/A';
    if (sharedBy.includes('undefined undefined')) return '[Deleted User]';
    return sharedBy.trim();
};
